import { routes as rentPaymentRoutes } from './rent-payment'

export const routes = {
  ...rentPaymentRoutes,
}
